import ko from 'date-fns/locale/ko';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import DropdownSelect from '../../components/DropdownSelect';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import { useToast } from '../../controller/ToastController';

registerLocale('ko', ko);
interface RegularHolidayType {
  dateType: { key: number; value: number; label: string; name: string };
  dateOfWeek: { key: number; value: number; label: string; name: string };
}
interface TemporaryHolidayType {
  startDate: Date | null;
  endDate: Date | null;
}

const dateTypeList = [
  { key: 1, value: 1, name: '매주', label: '매주' },
  { key: 2, value: 2, name: '매달 첫주', label: '매달 첫주' },
  { key: 3, value: 3, name: '매달 둘째주', label: '매달 둘째주' },
  { key: 4, value: 4, name: '매달 셋째주', label: '매달 셋째주' },
  { key: 5, value: 5, name: '매달 넷째주', label: '매달 넷째주' },
  { key: 6, value: 6, name: '매달 다섯째주', label: '매달 다섯째주' },
];
const dateOfWeekList = [
  { key: 0, value: 0, name: '일요일', label: '일요일' },
  { key: 1, value: 1, name: '월요일', label: '월요일' },
  { key: 2, value: 2, name: '화요일', label: '화요일' },
  { key: 3, value: 3, name: '수요일', label: '수요일' },
  { key: 4, value: 4, name: '목요일', label: '목요일' },
  { key: 5, value: 5, name: '금요일', label: '금요일' },
  { key: 6, value: 6, name: '토요일', label: '토요일' },
];

const StoreHoliday = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [regularHoliday, setRegularHoliday] = useState<RegularHolidayType[]>([]);
  const [temporaryHoliday, setTemporaryHoliday] = useState<TemporaryHolidayType[]>([]);
  const [isMobile, setIsMobile] = useState(false);

  // 정기 휴무 추가하기
  const addRegularHoliday = () => {
    const newHoliday: RegularHolidayType = {
      dateType: dateTypeList[0],
      dateOfWeek: dateOfWeekList[1],
    };

    setRegularHoliday((prevRegularHolidays) => [...prevRegularHolidays, newHoliday]);
  };

  // 임시 휴무 추가하기
  const addTemporaryHoliday = () => {
    const currentDate = new Date();
    setTemporaryHoliday((prevTemporaryHolidays: TemporaryHolidayType[]) => [
      ...prevTemporaryHolidays,
      {
        startDate: currentDate,
        endDate: currentDate,
      },
    ]);
  };
  const deleteTemporaryHoliday = (index: number) => {
    setTemporaryHoliday((prevTemporaryHolidays: TemporaryHolidayType[]) =>
      prevTemporaryHolidays.filter((_, i) => i !== index),
    );
  };

  // 휴무일 등록
  const setHoliday = async () => {
    try {
      const regular_holiday = regularHoliday.map((item) => ({
        day_of_week: item.dateOfWeek.value,
        date_type: item.dateType.value,
      }));
      const temporary_closure = temporaryHoliday.map((item: any) => ({
        holiday_from: new Date(item.startDate)
          .toLocaleDateString('ko-KR')
          .replace(/\./g, '-')
          .replace(/-$/, '')
          .replace(/\s/g, ''),
        holiday_to: new Date(item.endDate)
          .toLocaleDateString('ko-KR')
          .replace(/\./g, '-')
          .replace(/-$/, '')
          .replace(/\s/g, ''),
      }));

      const oData = {
        store_id: currentStore.value,
        regular_holiday: regular_holiday,
        temporary_closure: temporary_closure,
      };
      const oResp = await StoreController.setHoliday(oData);
      let oResponse: any;
      if (oResp && oResp.data) {
        oResponse = oResp.data;
      }
      if (oResponse !== undefined) {
        if (!oResponse) {
          showToast('저장하지 못하였습니다. 다시 시도해 주세요.', 'error');
        } else {
          showToast('저장되었습니다.');
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 휴무일 가져오기
  const getHoliday = async () => {
    console.log('1');
    try {
      const iStoreId = currentStore.value;
      const oResp = await StoreController.getHoliday(iStoreId);

      if (oResp && oResp.data) {
        const oResponse = oResp.data;

        const regularHlidayData = oResponse.data.regular_holiday.map((item: any) => ({
          day_of_week: item.day_of_week,
          date_type: item.date_type,
        }));
        const temporaryClosureData = oResponse.data.temporary_closure.map((item: any) => ({
          startDate: new Date(item.holiday_from),
          endDate: new Date(item.holiday_to),
        }));

        if (oResponse.ok) {
          setRegularHoliday(
            regularHlidayData.map((item: any) => ({
              dateType: dateTypeList.find((option) => option.value === item.date_type),
              dateOfWeek: dateOfWeekList.find((option) => option.value === item.day_of_week),
            })),
          );
          setTemporaryHoliday(temporaryClosureData);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 모바일 달력 체크
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
      console.log('isMobile', isMobile);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    getHoliday();
    console.log('2');
  }, [currentStore]);

  const RegularDayComponent: React.FC<{ item: RegularHolidayType; index: number }> = ({
    item,
    index,
  }) => {
    const onChangeRegularHoliday = (selectedOption: any) => {
      setRegularHoliday((prevRegularHolidays) => {
        const updatedRegularHolidays = [...prevRegularHolidays];
        updatedRegularHolidays[index] = {
          ...item,
          dateType: selectedOption,
        };
        return updatedRegularHolidays;
      });
    };
    const onChangeDayOfWeek = (selectedOption: any) => {
      setRegularHoliday((prevRegularHolidays) => {
        const updatedRegularHolidays = [...prevRegularHolidays];
        updatedRegularHolidays[index] = {
          ...item,
          dateOfWeek: selectedOption,
        };
        return updatedRegularHolidays;
      });
    };

    const deleteRegularHoliday = () => {
      setRegularHoliday((prevRegularHolidays) => {
        const updatedRegularHolidays = [...prevRegularHolidays];
        updatedRegularHolidays.splice(index, 1);
        return updatedRegularHolidays;
      });
    };

    return (
      <div key={index}>
        <div className="selectWrap">
          <div className="selectDateWrap">
            <div className="dateSelect">
              <DropdownSelect
                options={dateTypeList}
                defaultValue={dateTypeList.find((option) => option.value === item.dateType?.value)}
                onChangeValue={onChangeRegularHoliday}
              />
            </div>
            <div className="dateSelect">
              <DropdownSelect
                options={dateOfWeekList}
                defaultValue={dateOfWeekList.find(
                  (option) => option.value === item.dateOfWeek?.value,
                )}
                onChangeValue={onChangeDayOfWeek}
              />
              {/* <Select
                options={dateOfWeekList}
                defaultValue={dateOfWeekList.find(
                  (option) => option.value === item.dateOfWeek?.value,
                )}
                onChange={onChangeDayOfWeek}
              /> */}
            </div>
            <button onClick={deleteRegularHoliday} className="deleteHoliday">
              <h3>삭제</h3>
            </button>
          </div>
        </div>
      </div>
    );
  };

  const TemporaryDay: React.FC<{ item: any; index: number }> = ({ item, index }) => {
    const [changeDate, setChangeDate] = useState<[Date | null, Date | null]>([
      item.startDate,
      item.endDate,
    ]);

    const handleDateChange = (dates: [Date | null, Date | null]) => {
      setChangeDate(dates);
      if (dates[0] !== null && dates[1] !== null) {
        onChangeTemporaryHoliday({ startDate: dates[0], endDate: dates[1] }, index);
      }
    };

    const onChangeTemporaryHoliday = (
      dates: { startDate: Date | null; endDate: Date | null },
      index: number,
    ) => {
      setTemporaryHoliday((prevTemporaryHolidays: any[]) => {
        const updatedTemporaryHolidays = [...prevTemporaryHolidays];
        const currentItem = updatedTemporaryHolidays[index];

        currentItem.startDate = dates.startDate;
        currentItem.endDate = dates.endDate;

        return updatedTemporaryHolidays;
      });
    };

    return (
      <div className="selectWrap">
        <div className="selectDateWrap">
          <div className="calendarWrap">
            <DatePicker
              id={`datepicker${index}`}
              className="datePicker"
              key={index}
              selectsRange={true}
              startDate={changeDate[0]}
              endDate={changeDate[1]}
              onChange={(update) => handleDateChange(update)}
              dateFormat="yyyy-MM-dd"
              isClearable={false}
              locale="ko"
              monthsShown={isMobile ? 1 : 2}
              minDate={new Date()}
              disabledKeyboardNavigation={true}
              onFocus={(e) => {
                e.preventDefault();
                e.target.blur();
              }}
            />
            <label className="calendar" htmlFor={`datepicker${index}`}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="달력아이콘" />
            </label>
          </div>

          <button className="deleteHoliday" onClick={() => deleteTemporaryHoliday(index)}>
            <h3>삭제</h3>
          </button>
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        <div className="contentWrap">
          {/* <div className="title">
            <h2>휴무설정</h2>
          </div> */}
          <div className="dateWrap">
            <h3>정기휴무</h3>
            {regularHoliday.map((item: RegularHolidayType, index: number) => (
              <RegularDayComponent key={index} item={item} index={index} />
            ))}
            <button className="addButton" onClick={addRegularHoliday}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가하기 아이콘" />
              <h3>정기휴무 추가하기</h3>
            </button>
          </div>
          <div className="dateWrap">
            <h3>임시휴무</h3>
            {temporaryHoliday.map((item: TemporaryHolidayType, index: number) => {
              return <TemporaryDay key={index} item={item} index={index} />;
            })}
            <button className="addButton" onClick={addTemporaryHoliday}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가하기 아이콘" />
              <h3>임시휴무 추가하기</h3>
            </button>
          </div>
          <button onClick={setHoliday} className={`submitButton`}>
            휴무일 등록하기
          </button>
        </div>
      </div>
    </Style>
  );
};

export default StoreHoliday;

const Style = styled.div`
  /* 공통 */
  h2,
  h3 {
    font-size: 16px;
    font-weight: 500;
    color: #555555;
  }
  h3 {
    margin-bottom: 10px;
    font-size: 14px;
  }
  .title {
    margin-bottom: 20px;
  }

  /* dateWrap */
  .dateWrap {
    margin-bottom: 40px;
  }
  .selectWrap {
    width: 100%;
    margin-bottom: 10px;
  }

  .selectDateWrap {
    display: flex;
    align-items: center;
    gap: 10px;

    .dateSelect {
      flex: 1;
    }
    p {
      margin: 0 15px;
      color: #979797;
    }
  }

  /* addButton */
  .addButton {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    padding: 8px 14px;
    border: 1px solid #4dd2ae;
    border-radius: 5px;

    h3 {
      margin: 0 0 0 23px;
      font-size: 14px;
      font-weight: 600;
      color: #4dd2ae;
      line-height: 0;
    }
  }

  /* submitButton */
  .submitButton {
    margin-top: 60px;
  }
  .calendarWrap {
    position: relative;
    width: 100%;

    .calendar {
      position: absolute;
      right: 20px;
      top: 9px;
    }
  }
  .deleteHoliday {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    padding: 4px 14px;
    border: 1px solid #4dd2ae;
    border-radius: 5px;

    h3 {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: #4dd2ae;
    }
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    /* z-index:1; */
    input {
      background: none;
    }
  }
  .selectList {
    height: auto !important;
    min-height: 100% !important;
    background: #fff;
    /* z-index: 2; */
  }

  @media (max-width: 600px) {
    .selectDateWrap p {
      margin: 0;
    }
  }
`;
